module.exports = __webpack_public_path__ + "static/media/มะเส็ง.0cabcb56.png";